import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./quick_add_simple_items_mode.js";
//#region src/quick_add_simple_items_mode_helper.ts
var quick_add_simple_items_mode_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(mode) {
	switch (mode) {
		case "show-view-button": return "Show View Button";
		case "hide-view-button": return "Hide View Button";
		case "add-to-cart": return "Always Add to Cart";
		case "add-to-cart-with-quantity": return "Always Add to Cart with Quantity";
	}
}
//#endregion
export { name, quick_add_simple_items_mode_helper_exports };

//# sourceMappingURL=quick_add_simple_items_mode_helper.js.map